import { render, staticRenderFns } from "./InformacionComisionesFintouch.vue?vue&type=template&id=86b85388&"
import script from "./InformacionComisionesFintouch.vue?vue&type=script&lang=js&"
export * from "./InformacionComisionesFintouch.vue?vue&type=script&lang=js&"
import style0 from "./InformacionComisionesFintouch.vue?vue&type=style&index=0&id=86b85388&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports